import { AppSettings } from '../constants';
import Jwt from '../helper/interceptors';
import { MapResponse , ObjToParam} from '../helper/helper-api';

export const searchNewRequestList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(`api/dashboards/get-new-requests-from-home-owner?${ObjToParam(params.data)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getKeyMetricsList = () => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get('api/dashboards/key-metrics')
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getFilterLatestActivitiesList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .post('api/dashboards/get-activities', params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};



// WEBPACK FOOTER //
// ./src/Dashboard/api.js